// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"6fbb8175","105":"a03944a6"}[chunkId] + ".chunk.js";
};